export const mainBox = {
  height: '58vh',
  width: '70vw',
  overflowY: 'auto',
  overflowX: 'auto',
  maxWidth: '950px',
}

export const stackStyle = {
  gap: '15px',
  maxHeight: '55vh',
  overflow: 'auto',
  paddingTop: '5px',
}

export const stackBoxWrapper = {
  overflow: 'auto',
  height: 'auto',
  minWidth: 'auto',
}

export const smallScreenStackBoxWrapper = {
  overflow: 'auto',
  height: 'auto',
  minWidth: 'auto',
  maxWidth: '700px',
}

export const stackFont = {
  fontSize: '16px',
}

export const smallScreenStackFont = {
  fontSize: '16px',
}
export const parametersStack = {
  justifyContent: 'space-between',
  alignItems: 'center',
  bgcolor: '#F9F9F9',
  fontWeight: 'bold',
}

export const XSmallScreenMinMaxStack = {
  justifyContent: 'center',
}

export const smallScreenMinMaxStack = {
  paddingLeft: '25px',
  justifyContent: 'center',
}

export const minMaxStack = {
  paddingLeft: '20px',
  justifyContent: 'left',
}

export const smallScreenAvarageBox = {
  textAlign: 'right',
  paddingRight: '15px',
}

export const avarageBox = {
  textAlign: 'right',
  paddingRight: '55px',
}

export const paramsMainStack = {
  alignItems: 'flex-start',
  justifyContent: 'center',
  paddingTop: '5px',
  bgcolor: '#F9F9F9',
  height: '70px',
}

export const paramsMainBoldStack = {
  alignItems: 'flex-start',
  justifyContent: 'center',
  paddingTop: '5px',
  bgcolor: '#F9F9F9',
  height: '50px',
  fontWeight: '750',
}

export const stackBoxWraper = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
}

export const valuesStack = {
  justifyContent: 'center',
  alignItems: 'flex-start',
}

export const maxValuesBox = {
  paddingLeft: '18px',
}

export const helperTextStyle = {
  bgcolor: '#F9F9F9',
}

export const rightHelperTextStyle = {
  color: 'red',
  fontSize: '0.75rem',
  whiteSpace: 'nowrap',
  width: '100%',
  justifyContent: 'flex-end',
  transform: 'translateX(-10px)',
  textAlign: 'left',
  direction: 'rtl',
  maxHeight: '15px',
  minHeight: '15px',
  bgcolor: '#F9F9F9',
}

export const sRightHelperTextStyle = {
  color: 'red',
  fontSize: '0.75rem',
  whiteSpace: 'nowrap',
  width: '100%',
  justifyContent: 'flex-end',
  textAlign: 'left',
  direction: 'rtl',
  transform: 'translateX(30px)',
  maxHeight: '15px',
  minHeight: '15px',
  bgcolor: '#F9F9F9',
}

export const smallScreenRightHelperTextStyle = {
  color: 'red',
  fontSize: '0.6rem',
  whiteSpace: 'nowrap',
  width: '100%',
  justifyContent: 'flex-start',
  transform: 'translateX(28px)',
  textAlign: 'left',
  direction: 'rtl',
  margin: 0,
  maxHeight: '15px',
  minHeight: '15px',
  bgcolor: '#F9F9F9',
}

export const XSmallScreenRightHelperTextStyle = {
  color: 'red',
  fontSize: '0.6rem',
  whiteSpace: 'nowrap',
  width: '100%',
  justifyContent: 'flex-start',
  transform: 'translateX(10px)',
  textAlign: 'left',
  direction: 'rtl',
  margin: 0,
  maxHeight: '15px',
  minHeight: '15px',
  bgcolor: '#F9F9F9',
}

export const leftSmallScreenHelperTextStyle = {
  color: 'red',
  fontSize: '0.65rem',
  width: '140%',
  justifyContent: 'flex-start',
  textAlign: 'left',
  transform: 'translateX(-13px)',
  lineHeight: 1,
  maxHeight: '20px',
  minHeight: '20px',
  bgcolor: '#F9F9F9',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  whiteSpace: 'normal',
}

export const leftHelperTextStyle = {
  color: 'red',
  fontSize: '0.65rem',
  width: '140%',
  justifyContent: 'flex-start',
  textAlign: 'left',
  transform: 'translateX(-15px)',
  lineHeight: 0.9,
  maxHeight: '19px',
  minHeight: '19px',
  bgcolor: '#F9F9F9',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  whiteSpace: 'normal',
}

export const warningColor = {
  color: 'orange',
}

export const recalculateModalBoxWrapper = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}

export const recalculateModalWarningIcon = {
  width: 35,
  height: 35,
  marginRight: '0.7vw',
}

export const recalculateModalTitle = {
  fontSize: '1.5rem',
  fontWeight: 700,
}

export const recalculateModalText = {
  fontSize: '1.5rem',
  fontWeight: 500,
}

export const recalculateModalLongText = {
  fontSize: '1.5rem',
  fontWeight: 500,
  marginRight: '5vw',
  marginLeft: '5vw',
  whiteSpace: 'nowrap',
}
